
































































































































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import ChatStore from '@/components/Chat/Store/ChatStore'
import { AlteracaoDataMensagem, Snackbar, RequestMessage, IRequestMessage, AlteracaoDataAgendamento } from '@/types/_'
import Theme from '@/styles/Theme'
import { DateTime } from 'luxon'
import { maskDateTime, timeoutDefault, maskDate } from '@/utils/common'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'
import SolicitacaoClinicaStore from './store/SolicitacaoClinicaStore'

@Component

export default class ModalSolicitacaoAlteracaoDataAgendamentoClinica extends Vue {
  @Prop() tipoUsarioHospital: boolean
  @Prop() solicitacaoId: string
  @Prop({ default: true }) podeEditar: boolean

  $refs: {
    dateA: any,
    dateB: any,
    dateC: any,
    agendamentoChat: any,
  }

  loadClose: boolean = false

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  windowHeight: number = 0
  mensagem: string = ''
  mensagemError: any = {
    dateText: '',
    dateText2: '',
    dateText3: '',
  }

  snackBar: Snackbar = {
    disabled: false,
    disabledBtn: false,
    show: false,
    timeout: 6000,
    message: 'Houver um erro ao enviar a mensagem.',
    color: '#d3f2f2',
  }

  date: any = ''

  dateText: string = ''

  modalHeight: number = 0

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getChatStore() {
    return getModule(ChatStore, this.$store)
  }

  get getdateText() {
    this.dateText = this.formatISOToDate(this.date)
    return this.dateText
  }

  set getdateText(value: string | Date) {
    this.dateText = this.formatISOToDate(this.date)
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get showModal() {
    const show = this.getSolicitacaoStore.modalSolicitacaoCirurgia.showAlteracaoDataSolicitadaClinica
    if (show) {
      this.modalIsOpened()
    } else {
      this.modalIsClosed()
    }
    return show
  }

  set showModal(value: boolean) {
    this.getSolicitacaoStore.setShowAlteracaoDataAgendamentoClinica(value)
  }

  get getTheme() {
    return Theme
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(value: string) {
    this.mensagem = value
  }

  getDateFormat() {
    return DateTime.local().toFormat('yyyy-LL-ddT12:00')
  }

  positionRight(mensagemHospital: boolean) {
    return this.tipoUsarioHospital === mensagemHospital
  }

  positionLeft(mensagemHospital: boolean) {
    return this.tipoUsarioHospital !== mensagemHospital
  }

  clearDate(elements: string[]) {
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i]
      this[element] = ''
    }
  }

  clickDateTimeA(event) {
    if (!this.date) {
      this.date = moment(new Date()).format('YYYY-MM-DDT12:00')
    }

    this.$refs.dateA.open(event)
  }

  formatISOToDate(value: string | Date) {
    if (value === '') return value
    return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_MED)
  }

  formatHour(date) {
    return maskDateTime(date)
  }

  formatDate(date) {
    return maskDate(date)
  }

  isValid() {
    this.mensagemError.dateText = ''

    if (!this.dateText) {
      this.mensagemError.dateText = 'Por favor informe a data e hora.'
      return false
    }

    return true
  }

  get solicitacaoClinicaStore() {
    return getModule(SolicitacaoClinicaStore, this.$store)
  }

  async confirmar() {
    this.setLoadingRequest(true, this.getSolicitacaoStore.requestMessage.avancar.text)

    if (this.isValid()) {
      const data = {
        solicitacaoId: this.solicitacaoId,
        data: {
          dataAgendamento: DateTime.fromISO(this.date).setZone('America/Sao_Paulo').toISO(),
          dataVirtual: this.getPendenciaStore.agendamentoMedico.dataAgendamentoVirtual,
        },
      }

      const res = await this.solicitacaoClinicaStore.atualizarDataAgendamento(data)

      if (res.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Data do agendamento alterado com sucesso.', icon: 'done', color: '#2E7D32' })

        this.getPendenciaStore.agendamentoMedico.dataAgendamento = this.date
        this.closeModal()
        this.getChatStore.clearAlteracaoDataAgendamento()
        this.clear()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao alterar a data do agendamento.', icon: 'warning', color: '#C62828' })

        this.snackBar.show = true
        this.snackBar.disabled = true
        this.snackBar.color = '#d3f2f2'
        this.snackBar.message = res.message || 'Houver um erro ao enviar a mensagem.'
        this.getSolicitacaoStore.setSnackbar(this.snackBar)
      }
    }

    this.clearLoadingRequest()
  }

  clear() {
    this.getSolicitacaoStore.clearAlteracaoDataAgendamento()
    this.getMensagem = ''
    this.getdateText = ''
    this.date = ''
    this.mensagemError = {
      dateText: '',
    }
  }

  async closeModal() {
    this.loadingClose = true
    await timeoutDefault()
    this.getSolicitacaoStore.setShowAlteracaoDataAgendamentoClinica(false)
    this.clear()
    this.loadingClose = false
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('main-chat-scroll')
    const option: ScrollToOptions = {
      behavior: 'smooth',
      left: 0,
      top: ele[0].scrollHeight + 200,
    }
    ele[0].scrollTo(option)
  }

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      const documentHeight = doc.documentElement.clientHeight
      this.windowHeight = documentHeight
      const documentWidth = doc.documentElement.clientWidth
      const modalMain = (doc.querySelector('.modal-alterar-data__main') as HTMLDivElement).scrollHeight
      const modalToolbar = (doc.querySelector('.modal-alterar-data__toolbar') as HTMLDivElement).scrollHeight
      const modalHeader = (doc.querySelector('.modal-alterar-data__header') as HTMLDivElement).scrollHeight
      const modalActions = (doc.querySelector('.modal-alterar-data__actions') as HTMLDivElement).scrollHeight
      const chatInput = (doc.querySelector('.main-chat__send') as HTMLDivElement).scrollHeight
      const variation = !this.getDeviceOrientation() ? 46 : 90
      this.modalHeight = modalMain - modalToolbar - modalActions - modalHeader - chatInput - variation
    } else {
      this.modalHeight = 0
    }
  }

  async mounted() {
    await this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowHeight)
      window.addEventListener('orientationchange', this.getDeviceOrientation)
      this.getWindowHeight()
      this.getDeviceOrientation()
    })
  }

  async updated() {
    await this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowHeight)
      window.addEventListener('orientationchange', this.getDeviceOrientation)
      this.getWindowHeight()
      this.getDeviceOrientation()
    })
    this.scrollToMensagem()
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowHeight)
  }

  getDeviceType() {
    const ua = window.navigator.userAgent
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return 'tablet'
    }
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return 'mobile'
    }
    return 'desktop'
  }

  handleOrientationChange() {
    return window.screen.orientation.type
  }

  getDeviceOrientation() {
    const orientation = this.handleOrientationChange() === 'landscape-primary'
    const type = this.getDeviceType() === 'mobile'
    return orientation && type
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }


  modalIsOpened() {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'
    if (html) {
      html.classList.add(noOverflowClass)
    }

    this.date = this.getPendenciaStore.agendamentoMedico.dataAgendamento || ''
  }

  modalIsClosed() {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'
    if (html) {
      html.classList.remove(noOverflowClass)
    }
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  loadMensagem: boolean = false

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(value: boolean) {
    this.loadMensagem = value
  }

  get placeholder() {
    return this.getdateText === '' ? 'Escolha uma data para poder digitar uma mensagem...' : 'Mensagem'
  }

  clearMensagem() {
    this.getMensagem = ''
  }

  async send() {
    const responseMessage: IRequestMessage = new RequestMessage()
    this.loadingMensagem = true
    const mensagem: AlteracaoDataMensagem = {
      mensagemHospital: this.tipoUsarioHospital,
      hospitalId: '',
      dataEnvio: DateTime.local().toISO(),
      mensagem: this.$sanitize(this.getMensagem),
    }

    this.getMensagem = ''
    const response = await this.getChatStore.sendDataAgendamentoMensagem(mensagem)

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingMensagem = false
  }
}

